import { defineMessages } from "react-intl";

export const scope = "components.DepositData";

export const messages = defineMessages({
  accountToTransfer: {
    id: `${scope}.accountToTransfer`,
    defaultMessage: "Cuenta a transferir",
  },
  copyAll: {
    id: `${scope}.copyAll`,
    defaultMessage: "COPIAR TODO",
  },
  emptyCase: {
    id: `${scope}.emptyCase`,
    defaultMessage:
      "Los datos no pueden ser mostrados en este {br}momento. Por favor contactate con soporte.",
  },
});
